import "../team/styles.sass";

import React, { FC, useContext, useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import Button from "../../../components/UI/button/GgButton";
import { Context } from "../../..";
import Emptiness from "../../../components/UI/emptiness/Emptiness";
import Timofey from "../../../assets/images/Timofey_avatar.png";
import Spinner from "../../../components/UI/spinner/Spinner";
import { FAQBlock, IContent } from "../../../models/IPages";
import GuideBlock from "../blocks/GuideBlock";
import {
  createFileFromBase64,
  getImageExtensionFromBase64,
  removeKeyFromObject,
} from "../../../utils";
import FaqHeaderBlock from "./blocks/FaqHeaderBlock";
import FaqBlock from "./blocks/FaqBlock";
import { AddIcon } from "../../../assets/icons";

const FAQ: FC = () => {
  const { pages, store, roles } = useContext(Context);

  const categoryType = window.location.pathname.split("/").pop() || "";
  const [adminPermissionData, setAdminPermissionData] = useState<any>()

  const [faqHeaderBlock, setFaqHeaderBlock] = React.useState<IContent>({
    heading: "",
    image: "",
    images: []
  });

  const [faqBlock, setFaqBlock] = React.useState<FAQBlock>({
    title: "",
    subtitle: "",
    description: [{
      heading: "",
      content: ""
    }]
  });

  useEffect(() => {
    pages
      .loadList(categoryType)
      .then((res: any) => {
        handleFillData(res.content);
      })
      .catch(console.log);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages]);

  const handleSave = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData();
    [
      faqHeaderBlock,
      faqBlock,
    ].forEach((object, index) => {
      // remove base64 images from object
      const filteredObject = removeKeyFromObject(object, "images");
      // Convert object data to JSON string
      const objectData = JSON.stringify(filteredObject);
      const objectKey = Object.keys({
        faqHeaderBlock,
        faqBlock
      })[index];

      formData.append(objectKey, objectData);
      // Add images to the FormData
      if (object?.images && object.images.length > 0) {
        object.images.forEach((base64Image: string, imageIndex: number) => {
          if (base64Image) {
            let base64Data =
              base64Image?.split(",")?.[1] ||
              base64Image?.split(";base64,").pop() ||
              "";
            const ext = getImageExtensionFromBase64(base64Image);
            const image = createFileFromBase64(
              base64Data,
              `${objectKey}${imageIndex + 1}.${ext || "jpg"}`,
              `image/${ext || "jpg"}`
            );

            formData.append(`${objectKey}${imageIndex + 1}`, image);
          }
        });
      }
    });

    pages
      .updateOne(categoryType, formData)
      .then(() => {
        pages
          .loadList(categoryType)
          .then((res: any) => {
            handleFillData(res.content);
          })
          .catch(console.log);
      })
      .catch(console.log);
  };

  const handleFillData = (content: any) => {
    if (content) {
      setFaqHeaderBlock(content[0]?.faqHeaderBlock)
      setFaqBlock(content[1]?.faqBlock)
    }
  };

  const ref = useRef<HTMLDivElement>(null);

  const CreateNewFAQ = () => {
    setFaqBlock((prev: any) => {
      const newData = { ...prev };
      newData?.description?.push({ heading: "", content: "" });
      return newData;
    });
  };

  useEffect(() => {
    loadNewData()
  }, [])

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "pages")?.children?.find((child: any) => child.path === "faq")
    setAdminPermissionData(userData)
  };

  return (
    <div
      ref={ref}
      className="team-page" style={{ "opacity": "1" }}>
      {Object.keys(pages.pageContent).length > 0 &&
        !pages.loadingContentBool ? (
        <form className="body" onSubmit={handleSave}>
          <FaqHeaderBlock
            data={faqHeaderBlock}
            setData={setFaqHeaderBlock}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />
          <FaqBlock
            data={faqBlock}
            setData={setFaqBlock}
            categoryType={categoryType}
            CreateNewFAQ={CreateNewFAQ}
            scrollToBottom={() => {
              // ref.current && ref.current.scrollTo(0, ref.current.scrollHeight)
              if (ref.current) {
                ref.current.scrollTop = ref.current.scrollHeight;
              }
            }}
            actionData = {adminPermissionData}
          />
            <div className="button-Container-block" style={{position:'fixed', bottom:"0", right:"3rem", display:"flex", gap:"15px", padding:"10px"}}>
                {adminPermissionData?.edit || adminPermissionData?.delete ? 
                (
                  <>
                  <Button
                    label="Add Question"
                    icon={{ leftIcon: <AddIcon size="18" className="icon" /> }}
                    onPress={CreateNewFAQ}
                    stylesType="border"
                    // className="button"
                    style={{ opacity: "1"}}
                  />
                  <Button  label="Save" type="submit" />
                  </>
                ): ""}
            </div>
        </form>
      ) : Object.keys(pages.pageContent).length === 0 &&
        !pages.loadingContentBool ? (
        <Emptiness icon={Timofey} content="It's time to create some content!" />
      ) : (
        <div className="spinner-container">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default observer(FAQ);
